import React from 'react'
import { Tab } from 'semantic-ui-react'
import DontRepeat from 'src/components/tabs/DontRepeat'
import Repeat from 'src/components/tabs/Repeat'
import { AppContext } from 'src/context/AppContext'

const panes = [
  {
    menuItem: '繰り返し',
    render: () => (
      <Tab.Pane>
        <Repeat />
      </Tab.Pane>
    )
  },
  {
    menuItem: '1回のみ',
    render: () => (
      <Tab.Pane>
        <DontRepeat />
      </Tab.Pane>
    )
  }
]

class Tabs extends React.Component {
  onTabChange = actions => (_, { activeIndex }) => {
    const isRepeat = activeIndex === 0
    actions.setRepeat(isRepeat)
  }
  render () {
    return (
      <AppContext.Consumer>
        {({ state, actions }) => (
          <Tab
            panes={panes}
            activeIndex={state.isRepeat ? 0 : 1}
            onTabChange={this.onTabChange(actions)}
          />
        )}
      </AppContext.Consumer>
    )
  }
}

export default Tabs
